/**
 * DBA / vanity QuickLink path helpers.
 * URL: /{urlSlug||clientId}/{sharedAppId}
 * API keys and offers always use SharedApp.clientId.
 */

/** Lowercase alphanumeric only (matches typical clientId URL style). */
export function normalizeUrlSlug(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
}

/** Path segment used in formUrl / apply routes. */
export function sharedAppUrlPathClient(sharedAppOrClientId) {
  if (sharedAppOrClientId == null) return "";
  if (typeof sharedAppOrClientId === "string") {
    return normalizeUrlSlug(sharedAppOrClientId) || String(sharedAppOrClientId).trim().toLowerCase();
  }
  const slug = normalizeUrlSlug(sharedAppOrClientId.urlSlug);
  if (slug) return slug;
  return String(sharedAppOrClientId.clientId || "")
    .trim()
    .toLowerCase();
}

/**
 * True when the URL :client param matches urlSlug or clientId
 * (so legacy /{clientId}/… links keep working after a DBA slug is set).
 */
export function matchesSharedAppUrlPathClient(sharedApp, pathClient) {
  const path = String(pathClient || "")
    .trim()
    .toLowerCase();
  if (!path || !sharedApp) return false;
  const slug = normalizeUrlSlug(sharedApp.urlSlug);
  const clientId = String(sharedApp.clientId || "")
    .trim()
    .toLowerCase();
  if (slug && path === slug) return true;
  if (clientId && path === clientId) return true;
  return false;
}

/**
 * Rewrite the client/DBA path segment in an existing formUrl, keeping host and path style.
 * Supports /{client}/{id}, /{integrator}/{client}/{id}, /{integrator}/{client}/la/{id}, /glp/{client}/…
 * Leaves /goodleapplus/{orgId} unchanged (no client slug in that path).
 */
export function applyUrlSlugToFormUrl(formUrl, sharedAppId, clientId, urlSlug) {
  const pathClient = sharedAppUrlPathClient({ clientId, urlSlug });
  const id = String(sharedAppId || "").trim();
  const existing = String(formUrl || "").trim();
  if (!existing || !id || !pathClient) return existing || formUrl;

  try {
    const u = new URL(existing);
    const parts = u.pathname.split("/").filter(Boolean);
    const idIdx = parts.findIndex((p) => p === id);
    if (idIdx < 0) return existing;

    if (parts[0] === "goodleapplus") {
      return existing;
    }
    if (parts[0] === "glp" && idIdx >= 2) {
      parts[1] = pathClient;
    } else if (parts[idIdx - 1] === "la" && idIdx >= 2) {
      parts[idIdx - 2] = pathClient;
    } else if (idIdx >= 1) {
      parts[idIdx - 1] = pathClient;
    } else {
      return existing;
    }
    u.pathname = `/${parts.join("/")}`;
    return u.toString();
  } catch {
    return existing;
  }
}
